var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStartSurvey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7516 8.11187L16.6086 6.2549C18.6995 4.164 21.4369 3.29672 24.3339 3.15499C25.4607 3.09987 26.0241 3.0723 26.4759 3.5241C26.9277 3.97589 26.9001 4.53929 26.845 5.66612C26.7032 8.56313 25.836 11.3005 23.7451 13.3914L21.8881 15.2484C20.3589 16.7776 19.9241 17.2125 20.2451 18.8713C20.562 20.1384 20.8686 21.3654 19.9472 22.2868C18.8296 23.4044 17.8101 23.4044 16.6925 22.2868L7.71322 13.3075C6.59561 12.1899 6.59557 11.1704 7.71322 10.0527C8.63459 9.13137 9.86161 9.43806 11.1287 9.75487C12.7875 10.0759 13.2224 9.64112 14.7516 8.11187Z",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2449 8.75H21.2561",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 26.875L9.375 20.625",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 26.875L13.125 24.375",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 19.375L5.625 16.875",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStartSurvey);
export default __webpack_public_path__ + "static/media/icon-start-survey.e5882084ebce3d12f1e696842a220723.svg";
export { ForwardRef as ReactComponent };